__turbopack_context__.v({
  "chip": "chip-module-scss-module__T9dRAq__chip",
  "chip--interactive": "chip-module-scss-module__T9dRAq__chip--interactive",
  "chip--is-rounded": "chip-module-scss-module__T9dRAq__chip--is-rounded",
  "chip--not-clickable": "chip-module-scss-module__T9dRAq__chip--not-clickable",
  "chip--small": "chip-module-scss-module__T9dRAq__chip--small",
  "chip--theme-active": "chip-module-scss-module__T9dRAq__chip--theme-active",
  "chip--theme-emphasis": "chip-module-scss-module__T9dRAq__chip--theme-emphasis",
  "chip--theme-light": "chip-module-scss-module__T9dRAq__chip--theme-light",
  "chip__icon-container": "chip-module-scss-module__T9dRAq__chip__icon-container",
});
